// extracted by mini-css-extract-plugin
module.exports = {"sessionBox":"InterventionNotes_sessionBox__1U3TZ","modalHeader":"InterventionNotes_modalHeader__3-KoZ"};